// src/locales/en/errors.js
export const errors = {
    somethingWentWrong: "ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    networkError: "நெட்வொர்க் பிழை. தயவுசெய்து உங்கள் இணைப்பைச் சரிபார்க்கவும்.",
    permissionDenied: "அனுமதி மறுக்கப்பட்டது. இந்த வளத்திற்கு உங்களுக்கு அணுகல் இல்லை.",
    pageNotFound: "பக்கம் கிடைக்கவில்லை",
    notFound: "கிடைக்கவில்லை",
    sessionExpired: "உங்கள் அமர்வு காலாவதியாகிவிட்டது. தயவுசெய்து மீண்டும் உள்நுழையுங்கள்.",
    invalidData: "தவறான தரவு வழங்கப்பட்டது",
    serverError: "சர்வர் பிழை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    loadingError: "ஏற்றுதல் பிழை",
}